<template>
	<div class="wd-theme-back">
		<Top></Top>
		<div class="wd-container wd-theme-back-fff">
			<div class="wd-lh-40 wd-m-t-20 wd-p-20">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/member' }">会员中心</el-breadcrumb-item>
					<el-breadcrumb-item>我的订单</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<div class="orderstate wd-flex wd-row-between wd-container wd-theme-back-fff">
			<div class="left wd-row-noshrink">
				<div class="listseqno">订单号：{{ wddata.listseqno }}</div>
				<div class="statetext wd-theme" v-if="wddata.orderstate == 0">{{ wddata.orderstatetext }}</div>
				<div class="statetext" v-else>{{ wddata.orderstatetext }}</div>
				<div class="btn" v-if="wddata.orderstate == 0">
					<div><el-button type="primary" plain class="wd-p-l-30 wd-p-r-30" @click="gotopay">立即付款</el-button></div>
					<div class="wd-m-t-10"><el-button type="info" plain class="wd-p-l-30 wd-p-r-30" @click="canclepos">取消订单</el-button></div>
				</div>
				<div class="btn" v-else-if="wddata.orderstate == 3"><el-button type="primary" plain class="wd-p-l-30 wd-p-r-30" @click="commentedit">去评价</el-button></div>
			</div>
			<div class="right wd-row-grow">
				<div class="hint">感谢您在商城购物，欢迎您对本次交易及所购商品进行评价。</div>
				<div class="wd-flex wd-row-between progress">
					<el-steps :active="stepvalue" align-center finish-status="success" process-status="process" space="20%">
						<el-step title="提交订单" :description="wddata.listdate">
							<!-- <template slot="icon">
								<i class="wd-icon wd-font-26">&#xe611;</i>
							</template> -->
						</el-step>
						<el-step title="付款成功" :description="wddata.paydate">
							<!-- <template slot="icon">
								<i class="wd-icon wd-font-26">&#xe63f;</i>
							</template> -->
						</el-step>
						<el-step title="商品出库" :description="wddata.senddate">
							<!-- <template slot="icon">
								<i class="wd-icon wd-font-26">&#xe62b;</i>
							</template> -->
						</el-step>
						<el-step title="等待收货">
							<!-- <template slot="icon">
								<i class="wd-icon wd-font-26">&#xe622;</i>
							</template> -->
						</el-step>
						<el-step title="完成" :description="wddata.takedate">
							<!-- <template slot="icon">
								<i class="wd-icon wd-font-26">&#xe613;</i>
							</template> -->
						</el-step>
					</el-steps>
					<!-- <div class="ic ">
						<div><i class="wd-icon wd-font-26">&#xe611;</i></div>
						<div class="wd-m-t-20 wd-theme-000">
							<p>提交订单</p>
							<div class="wd-width-100">
							{{wddata.listdate}}
							</div>
						</div>
					</div>
					<div class="jdt" :class="wddata.orderstate==0?'no':'in'"></div>
					<div class="ic b">
						<div><i class="wd-icon wd-font-26">&#xe63f;</i></div>
						<div class="wd-m-t-20 wd-theme-000">付款成功</div>
					</div>
					<div class="jdt" :class="wddata.orderstate>0?'in':'no'"></div>
					<div class="ic c">
						<div><i class="wd-icon wd-font-26">&#xe62b;</i></div>
						<div class="wd-m-t-20 wd-theme-000">商品出库</div>
					</div>
					<div class="jdt" :class="wddata.orderstate>1?'in':'no'"></div>
					<div class="ic d">
						<div><i class="wd-icon wd-font-26">&#xe622;</i></div>
						<div class="wd-m-t-20 wd-theme-000">等待收货</div>
					</div>
					<div class="jdt" :class="wddata.orderstate>2?'in':'no'"></div>
					<div class="ic e">
						<div><i class="wd-icon wd-font-26">&#xe613;</i></div>
						<div class="wd-m-t-20 wd-theme-000">完成</div>
					</div> -->
				</div>
			</div>
		</div>
		<div class="orderstate noborder wd-m-t-20 wd-flex wd-row-between wd-container wd-theme-back-fff express">
			<div class="left wd-row-noshrink wd-flex wd-row-left">
				<div class="wd-img-100 wd-row-noshrink wd-m-r-10 wd-m-l-20"><el-image :src="picurl" class="wd-img-100"></el-image></div>
				<div class="wd-text-left">
					<div class="wd-lh-25">送货方式：{{ wddata.expressname }}</div>
					<div class="wd-lh-25">货运单号：{{ wddata.expressno }}</div>
				</div>
			</div>
			<div class="right wd-row-grow">
				<el-timeline :reverse="false">
					<el-timeline-item v-for="(activity, index) in expressdetail" :key="index" :timestamp="activity.ftime" :color="activity.color">
						{{ activity.context }}
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>
		<div class="orderinfo wd-container wd-theme-back-fff wd-m-t-20">
			<el-row>
				<el-col :span="8" class="wd-border-right wd-p-20">
					<div class="title wd-lh-30 wd-font-16">收货人信息</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">收货人：</div>
						<div class="memo wd-row-grow">{{ wddata.ordername }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">地址：</div>
						<div class="memo wd-row-grow">{{ wddata.orderaddr }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">手机号码：</div>
						<div class="memo wd-row-grow">{{ wddata.ordertelno | mobileFormatter }}</div>
					</div>
				</el-col>
				<el-col :span="8" class="wd-border-right wd-p-20">
					<div class="title wd-lh-30 wd-font-16">配送信息</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">配送方式：</div>
						<div class="memo wd-row-grow">{{ wddata.expressname }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">运费：</div>
						<div class="memo wd-row-grow">¥{{ wddata.expressmoney | amountFormatter }}</div>
					</div>
				</el-col>
				<el-col :span="8" class="wd-p-20">
					<div class="title wd-lh-30 wd-font-16">付款信息</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">付款方式：</div>
						<div class="memo wd-row-grow">在线支付</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">付款时间：</div>
						<div class="memo wd-row-grow">{{ wddata.paydate }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">商品总额：</div>
						<div class="memo wd-row-grow">¥{{ wddata.realamount2 | amountFormatter }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">促销优惠：</div>
						<div class="memo wd-row-grow">-¥{{ wddata.manjianamount | amountFormatter }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">订单金额：</div>
						<div class="memo wd-row-grow">¥{{ wddata.realamount | amountFormatter }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30" v-if="wddata.canuseintegral>0">
						<div class="subtitle wd-row-noshrink">积分支付：</div>
						<div class="memo wd-row-grow">{{ wddata.canuseintegral | amountFormatter }}分</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">余额支付：</div>
						<div class="memo wd-row-grow">¥{{ wddata.canuseamount | amountFormatter }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">优惠券：</div>
						<div class="memo wd-row-grow">-¥{{ wddata.couponamount | amountFormatter }}</div>
					</div>
					<div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">运费：</div>
						<div class="memo wd-row-grow">¥{{ wddata.expressmoney | amountFormatter }}</div>
					</div>
					<!-- <div class="wd-flex wd-row-between wd-lh-30">
						<div class="subtitle wd-row-noshrink">应支付金额：</div>
						<div class="memo wd-row-grow">¥{{ wddata.yfamount | amountFormatter }}</div>
					</div> -->
				</el-col>
			</el-row>
		</div>
		<div class="wd-container orderdetail wd-m-t-20">
			<div class="wd-lh-30 wd-theme-666">{{ wddata.stockname }}</div>
			<div class="title wd-flex wd-row-between wd-text-center">
				<div class="wd-row-grow">商品</div>
				<div class="wd-row-noshrink barcode">商品编号</div>
				<div class="wd-row-noshrink price">单价</div>
				<div class="wd-row-noshrink num">数量</div>
				<div class="wd-row-noshrink opt">操作</div>
			</div>
			<div class="detail wd-theme-back-fff">
				<div v-for="(item, index) in wddata.posdetail" :key="index" class=" wd-flex wd-row-between wd-col-top wd-p-t-20 wd-border-bottom">
					<div class="wd-row-grow wd-p-l-20 wd-flex wd-row-between wd-col-top">
						<div class="wd-img-100 wd-row-noshrink wd-m-r-20 wd-cursor"><el-image :src="$wdpicurl(item.pic1)" class="wd-img-60"></el-image></div>
						<div class="wd-row-grow wd-p-r-20">
							<span>{{ item.name }}</span>
							<span class="wd-m-l-5 wd-theme-999">{{item.prodate}}</span>
						</div>
					</div>
					<div class="wd-row-noshrink barcode wd-text-center">{{ item.barcode }}</div>
					<div class="wd-row-noshrink price wd-text-center">¥{{ item.price1 | amountFormatter }}</div>
					<div class="wd-row-noshrink num wd-text-center">{{ item.num | numberFormatter }}</div>
					<div class="wd-row-noshrink opt  wd-text-center">
						<div class="wd-cursor" v-if="item.orderstatetext=='待收货' && detail.servicenum==0" @click="afterservice(item.detailid)">申请售后</div>
						<div class="wd-m-t-20 wd-cursor " v-if="item.orderstatetext=='已收货' && detail.commentflag==0" @click="commentedit(item.detailid)">商品评价</div>
					</div>
				</div>
				<div class="wd-border-bottom"></div>
				<div class="wd-flex wd-row-between wd-p-20">
					<div></div>
					<div>
						<div class="wd-flex wd-lh-30">
							<div class="wd-width-100">商品总额：</div>
							<div class="">¥{{ wddata.realamount2 | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-30">
							<div class="wd-width-100">促销优惠：</div>
							<div class="">-¥{{ wddata.manjianamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-30">
							<div class="wd-width-100">优惠券：</div>
							<div class="">-¥{{ wddata.couponamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-30">
							<div class="wd-width-100">运 费：</div>
							<div class="">¥{{ wddata.expressmoney | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-30">
							<div class="wd-width-100">余额支付：</div>
							<div class="">¥{{ wddata.canuseamount | amountFormatter }}</div>
						</div>
						<div class="wd-flex wd-lh-30 " v-if="wddata.orderstate==0">
							<div class="wd-width-100">应付总额：</div>
							<div class="wd-font-26 wd-theme wd-font-bold">¥{{ wddata.yfamount | amountFormatter }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Orderdetail',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			wddata: [],
			picurl: '',
			posid: '',
			expressdetail: [],
			stepvalue: 0
		};
	},
	methods: {
		canclepos() {
			if (this.posid == '') {
				this.$wd_toast('操作异常', 'error');
				return;
			}
			if (this.wddata.orderstate != 0 && this.wddata.orderstate != 1) {
				this.$wd_toast('该单正在发货或已发货，不能取消，请与客服联系', 'error');
				return;
			}
			this.$confirm('确定取消订单吗？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$wd_request('canclepos', { posid: this.posid })
						.then(() => {
							this.$message({
								type: 'success',
								message: '订单取消成功!'
							});
						})
						.catch(() => {});
				})
				.catch(() => {});
		},
		gotopay() {
			if (this.posid == '') {
				this.$wd_toast('操作异常', 'error');
				return;
			}
			if (this.wddata.orderstate != 0) {
				this.$wd_toast('该单不能付款，请刷新重试', 'error');
				return;
			}
			this.$router.push({ name: 'Pay', query: { posid: this.posid, orderno: this.wddata.listseqno } });
		},
		loaddata() {
			let indata = {
				posid: this.posid
			};
			this.$wd_request('poslist', indata, true)
				.then(data => {
					this.wddata = data.value;
					this.picurl = this.$wdpicurl(this.wddata.posdetail[0].pic1);
					var expressmemo = data.value.expressmemo;
					if (expressmemo != null && expressmemo != '') {
						this.expressdetail = JSON.parse(expressmemo);
					}
					if (this.wddata.senddate != '') {
						this.expressdetail.push({ ftime: this.wddata.senddate, context: '订单发货' });
					}
					if (this.wddata.paydate != '') {
						this.expressdetail.push({ ftime: this.wddata.paydate, context: '订单付款成功' });
					}
					this.expressdetail.push({ ftime: this.wddata.listdate, context: '创建订单成功' });

					if (this.expressdetail.length > 0) {
						this.expressdetail[0].color = '#67C23A';
					}
					switch (this.wddata.orderstate) {
						case '0':
							this.stepvalue = 1;
							break;
						case '1':
							this.stepvalue = 2;
							break;
						case '2':
							this.stepvalue = 3;
							break;
						case '3':
							this.stepvalue = 5;
							break;
						case '4':
							this.stepvalue = 5;
							break;
						case '5':
							this.stepvalue = 0;
							break;
						case '6':
							this.stepvalue = 2;
							break;
						case '7':
							this.stepvalue = 2;
							break;
						case '8':
							this.stepvalue = 0;
							break;
					}
				})
				.catch(() => {
					console.log('nodata');
				});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		commentedit() {
			this.$router.push({ name: 'Commentedit',query:{posid:this.posid,orderno:this.listseqno} });
		},
		afterservice(detailid){
			console.log(detailid);
			this.$router.push({ name: 'Afterserviceedit',query:{posid:this.posid,orderno:this.listseqno,detailid:detailid} });
		}
	},
	activated() {
		
	},
	created() {
		var params = this.$route.query;
		let posid = params.posid || '';
		this.listseqno = params.orderno || '';
		if (posid !== '' && posid !== this.posid && this.listseqno !== '') {
			this.posid = posid;
			this.loaddata();
		}
	}
};
</script>

<style lang="scss" scoped>
.orderdetail {
	.title {
		background-color: #f9f9f9;
		height: 36px;
		line-height: 36px;
	}
	.barcode {
		width: 150px;
	}
	.price {
		width: 120px;
	}
	.num {
		width: 80px;
	}
	.opt {
		width: 150px;
	}
}
.orderinfo {
	.subtitle {
		width: 100px;
	}
}
.express {
	height: 300px;
	max-height: 300px;
	.right {
		height: 240px;
		max-height: 240px;
		overflow-y: auto !important;
		margin-left: 0 !important;
	}
}
::v-deep .el-steps {
	width: 100%;
}
.orderstate {
	border-top: 3px solid $wd-success;
	&.noborder {
		border: 0;
	}
	.left {
		width: 325px;
		padding: 20px 0 38px;
		text-align: center;
		.listseqno {
			margin: 30px 0;
			color: #999999;
		}
		.statetext {
			color: $wd-success;
			font-size: 24px;
			left: 34px;
			font-weight: 700;
		}
		.btn {
			margin-top: 30px;
		}
	}
	.right {
		border-left: 1px solid #f1f1f1;
		padding: 20px 20px 38px 20px;
		margin-left: 20px;
		.hint {
			height: 70px;
			overflow: hidden;
			color: #999999;
		}
		.progress {
			width: 100%;
			margin: 38px 0;
			position: relative;
			padding: 0 20px;
			.jdt {
				position: relative;
				width: 104px;
				height: 9px;
				margin-top: -70px;
				background: url(~@/assets/orderprogress.png) no-repeat;
				&.no {
					background-position: 0px -19px;
				}
				&.in {
					background-position: 0px -38px;
				}
			}
			.ic {
				overflow: hidden;
				color: $wd-success;
				height: 110px;
				text-align: center;
				&.a {
				}
				&.b {
				}
				&.c {
				}
				&.d {
				}
				&.e {
				}
			}
		}
	}
}
</style>
